import api from '@/services/api';
const ENTITY_ENDPOINT = 'material-tipo';

export class MaterialTipoService {
  /**
   * Obtiene todos los materiales tipo con filtros y paginación
   * @param {Object} params - Parámetros de filtrado y paginación
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAll(params = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}`, { params });
  }

  /**
   * Obtiene todos los materiales tipo con filtros utilizando getParamsUrl
   * @param {string} queryString - String de parámetros generado por getParamsUrl
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findAllWithQuery(queryString) {
    return await api.get(`/${ENTITY_ENDPOINT}?${queryString}`);
  }

  /**
   * Busca materiales tipo por nombre o criterio
   * @param {string} query - Término de búsqueda
   * @param {Object} additionalParams - Parámetros adicionales
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async search(query, additionalParams = {}) {
    return await api.get(`/${ENTITY_ENDPOINT}/`, {
      params: {
        Nombre: query,
        ...additionalParams,
      },
    });
  }

  /**
   * Obtiene un material tipo por su ID
   * @param {string|number} id - ID del material tipo
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async findById(id) {
    return await api.get(`/${ENTITY_ENDPOINT}/${id}`);
  }

  /**
   * Crea un nuevo material tipo
   * @param {Object} materialTipo - Datos del material tipo a crear
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async create(materialTipo) {
    return await api.post(`/${ENTITY_ENDPOINT}`, materialTipo);
  }

  /**
   * Actualiza un material tipo existente
   * @param {string|number} id - ID del material tipo
   * @param {Object} materialTipo - Datos del material tipo a actualizar
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async update(id, materialTipo) {
    return await api.patch(`/${ENTITY_ENDPOINT}/${id}`, materialTipo);
  }

  /**
   * Elimina un material tipo
   * @param {string|number} id - ID del material tipo
   * @returns {Promise<Object>} Respuesta de la API
   */
  static async delete(id) {
    return await api.delete(`/${ENTITY_ENDPOINT}/${id}`);
  }
}

export default MaterialTipoService;
